export const table = {
  empty: 'The table is missing data',
  empty_db: `<span class="block text-center">The table is missing data.</span>`,
  create_db: `Create Database`,
  overview: 'Overview',
  actions: 'Actions',
  show: 'Show',
  records: 'records',
  paginate_info: 'Showing {start} to {end} of {all} posts',
  loading: 'Please wait, we are loading data',
  error: 'Error loading data',
  last_date: 'In this section, statistics are available up to',
  need_select_filter: 'To view the list of available numbers - select a country',

  field: {
    id: 'ID',
    name: 'Name',
    naming: 'Name',
    title: 'Title',
    time_zone: 'Timezone',
    status: 'Status',
    type: 'Type',
    info: 'Information',
    created_at: 'Created at',
    updated_at: 'Updated at'
  },

  action: {
    edit: 'Edit',
    change: 'Edit',
    rename: 'Rename',
    duplicate: 'duplicate',
    delete: 'Delete',
    show: 'Show',
    hide: 'Hide',
    add_ip: 'Add IP'
  }
};
